import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { Link } from 'react-router-dom'
import { Tooltip, OverlayTrigger  } from 'react-bootstrap'

import PanelRowValues from 'modules/Charts/PanelRow/PanelRowValues'
import APPURL from 'utils/app/urls'
import IndicatorTools from 'utils/indicators/indicatorTools'
import messages from './messages'

class PanelRowContainer extends Component {
	constructor(props) {
		super(props)

		const {
			intl: { formatNumber, formatMessage }
		} = props

		this.formatNumber = formatNumber;
		this.formatMessage = formatMessage;

		this.state = {
			"lastCommonYear": "",
			"mostRecentYear": ""
		}
		this.allRegionsChartRef = React.createRef()
		this.referenceRegionsChartRef = React.createRef()
		this.sameCountryRegionsChartRef = React.createRef()

		this.unit = this.getUnit(props.indicatorsData)

		// var updateTime = this.updateTime.bind( this );
	}

	componentDidMount() {
		this.setState( {'loadinh': true} );
	}

	getUnit = indicatorsData => {
		const indicator_id = this.props.indicator;
		const indicatorData = indicatorsData.filter(item => item.id === indicator_id)[0];
		const unit = indicatorData.unit;

		return unit
	}

	renderValues() {
		let renderingComponentALL = null;
		let comparative = null;

		const indicatorData = this.props.indicatorsData.filter(item => item.id === this.props.indicator)[0]

		if (this.props.otherRegionsFilter !== undefined && this.props.otherRegionsFilter.length !== 0) {
			comparative = this.props.otherRegionsFilter[0]
		}

		let topLevelRegions = {
			"ctry": this.props.selectedRegionCountryMeta.id,
			"eu": this.props.allRegionsGroupRegionId
		};

		renderingComponentALL = (
			<PanelRowValues
				key={this.allRegionsChartRef}
				regionsData={JSON.stringify(this.props.regionsData)}
				indicator={this.props.indicator}
				indicatorData={indicatorData}
				unit={this.unit}
				selectedRegionId={this.props.selectedRegionId}
				comparative={comparative}
				config={'allRegions'}
				topLevelRegions={topLevelRegions}
				updateTime={this.updateTime.bind(this)}
			/>
		)


		return (
			<React.Fragment>
				{renderingComponentALL}
			</React.Fragment>
		)
	}

	updateTime( lastCommonYear, mostRecentYear ) {
		this.setState({
			"lastCommonYear": lastCommonYear,
			"mostRecentYear": mostRecentYear
		});
	}

	getTimeFragment() {
		const moreRecentDataAvail = this.state.lastCommonYear < this.state.mostRecentYear;

		if (moreRecentDataAvail) {
			const tooltip = <Tooltip id="tooltip">{this.formatMessage(messages.moreRecentDataAvail, {mostRecentYear: this.state.mostRecentYear})}</Tooltip>;

			return <React.Fragment>({this.state.lastCommonYear}<sup>
				<OverlayTrigger overlay={tooltip}><a>*</a>
			 	</OverlayTrigger></sup>)</React.Fragment>;
		} else {
			return <React.Fragment>({this.state.lastCommonYear})</React.Fragment>;
		}
	}

	renderIfAllOK() {
		const indicatorData = this.props.indicatorsData.filter(item => item.id === this.props.indicator)[0];
		const indicatorName = IndicatorTools.cleanIndicatorName( indicatorData.name );
		const indicatorUnit = IndicatorTools.cleanIndicatorUnit( indicatorData.unit );
		const actualURL = this.props.history.location.pathname;
		const indicatorDetailUrl = APPURL.getIndicatorDetailLink({ url: actualURL, indicator: indicatorData.id })

		const tooltip = <Tooltip id="tooltip">{this.formatMessage(messages.moreIndicatorDetail)}</Tooltip>;

		return (
			<div className="row obs-panel-row">
				<div className="col-lg-6 panel-indicator-title">
					<OverlayTrigger overlay={tooltip}>
						<Link to={indicatorDetailUrl}>
						<i className="fal fa-search-plus"></i>
						</Link>
			 		</OverlayTrigger>
			 		&nbsp;{indicatorName} <span className="text-gray-600">{this.getTimeFragment()}</span>
			 		<br />
			 		<small className='panel-indicator-unit'>
			 			{indicatorUnit}
			 		</small>
				</div>
				<div className="col-lg-6">
					{this.renderValues()}
				</div>
			</div>
		)
	}

	render() {
		return this.renderIfAllOK();
	}
}

export default injectIntl(PanelRowContainer)



// WEBPACK FOOTER //
// ./src/modules/Charts/PanelRow/PanelRowContainer/PanelRowContainer.jsx